import React from 'react'
import { observer } from 'mobx-react'
import PropTypes from 'prop-types'
import useSelection from '../hooks/use-selection'
import useModelKey from '../hooks/use-model-key'

function ToggleSelectionOnClick (props) {
  const selection = useSelection()
  const modelKey = useModelKey()

  const handleClick = () => {
    if (!modelKey) {
      return
    }

    if (props.multiple === false) {
      selection.clearSelected()
    }

    const toSelect = !selection.isSelected(modelKey)

    if (toSelect === true) {
      selection.add(modelKey)
    } else {
      selection.delete(modelKey)
    }
  }

  return (
    <>
      {React.Children.map(props.children, child => (
        React.cloneElement(child, { onClick: handleClick })
      ))}
    </>
  )
}

ToggleSelectionOnClick.defaultProps = {
  multiple: false
}

ToggleSelectionOnClick.propTypes = {
  multiple: PropTypes.bool.isRequired
}

export default observer(ToggleSelectionOnClick)
